var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoHomeOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.0776 259.629H14.3549C3.68998 259.629 -4.94366 245.409 6.22922 235.252C17.4021 225.095 230.702 33.1257 230.702 33.1257C230.702 33.1257 239.843 25 250 25C260.157 25 269.298 33.1257 269.298 33.1257C269.298 33.1257 482.598 225.095 493.771 235.252C504.944 245.409 496.31 259.629 485.645 259.629H438.922V450.583C438.922 464.295 429.781 475.976 411.498 475.976H329.225C314.498 475.976 304.848 462.772 304.848 451.599V313.462H195.152V451.599C195.152 462.772 185.502 475.976 170.775 475.976H88.5018C70.219 475.976 61.0776 464.295 61.0776 450.583V259.629ZM155 274V437H101V205L250 71L399 205V437H345V274H155Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoHomeOutline);
export default __webpack_public_path__ + "static/media/ico_home_outline.fba5bb8b1bc81e98edd3b650c509f3a2.svg";
export { ForwardRef as ReactComponent };